<template>
  <div class="overview -page">
    <h2>{{ data.first_name }} {{ data.last_name }}</h2>
    <p>soon..</p>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: { ...mapState("user", ["data"]) }
};
</script>
